import { render, staticRenderFns } from "./r-worker-team-page.vue?vue&type=template&id=ec3ab4de"
import script from "./r-worker-team-page.vue?vue&type=script&lang=js"
export * from "./r-worker-team-page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ec3ab4de')) {
      api.createRecord('ec3ab4de', component.options)
    } else {
      api.reload('ec3ab4de', component.options)
    }
    module.hot.accept("./r-worker-team-page.vue?vue&type=template&id=ec3ab4de", function () {
      api.rerender('ec3ab4de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/worker/r-worker-team-page.vue"
export default component.exports